import React from 'react'
import { Controller } from 'react-hook-form'
import { CivilitesMapping } from '../contactsSlice'
import AddressFields from '@/components/AddressFields'
import { Input } from '@/components/ui'

const CiviliteList = Object.keys(CivilitesMapping)

const PersonnePhysiqueForm = ({ control, errors = {}, apiErrors = {}}) => {

  // Fonction utilitaire pour obtenir l'erreur combinée (du form ou de l'API)
  const getErrorMessage = (fieldName) => 
    errors?.[fieldName]?.message || apiErrors?.[fieldName] || '';

  // Fonction utilitaire pour déterminer si un champ a une erreur
  const hasError = (fieldName) => 
    !!errors?.[fieldName] || !!apiErrors?.[fieldName]

  return (
      <div className="grid grid-cols-2 gap-2">
        <div className="flex flex-col items-center gap-2 pt-4">
          <Controller name="civilite"
            control={control}
            defaultValue={CiviliteList[0]}
            render={({field}) => (
              <label className="select w-2/3">
                <span className='label'>Civilité</span>
                <select {...field}>
                    { CiviliteList.map((civilite) => (
                      <option key={civilite} value={civilite}>{civilite}</option>
                    ))}
                </select>
              </label>
            )}
          />

          <div className='w-full flex flex-col items-center gap-2'>
            <Controller
              name="nom"
              control={control}
              defaultValue=""
              rules={{ required: "Le nom doit être renseigné" }}
              render={({ field  }) => (
                <>
                  <label className="input validator w-2/3"
                         {...(hasError('nom') ? {'aria-invalid': true} : {})}
                  >
                    <span className="label">Nom</span>
                    <input 
                      type="text" 
                      {...field}
                      value={field.value || ''} 
                    />
                  </label>
                  <p className="validator-hint hidden mt-0 w-2/3 empty:py-[0.6rem]">{getErrorMessage('nom')}</p>
                </>
              )}
            />
          </div>

          <div className='w-full flex flex-col items-center gap-2'>
            <Controller
              name="prenom"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <>
                  <label className="input w-2/3"
                         {...(hasError('prenom') ? {'aria-invalid': true} : {})}
                  >
                    <span className="label">Prénom</span>
                    <input 
                      type="text" 
                      {...field}
                      value={field.value || ''} 
                    />
                  </label>
                </>
              )}
            />
          </div>

          <div className='w-full flex flex-col items-center gap-2'>
            <Controller
              name="date_naissance"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <label className="input w-2/3">
                  <span className="label">Date de naissance</span>
                  <input 
                    type="date" 
                    {...field}
                    value={field.value || ''} 
                  />
                </label>
              )}
            />
          </div>

          <div className='w-full flex flex-col items-center gap-2'>
            <Controller
              name="lieu_naissance"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <label className="input w-2/3">
                  <span className="label">Lieu de naissance</span>
                  <input 
                    type="text" 
                    {...field}
                    value={field.value || ''} 
                  />
                </label>
              )}
            />
          </div>

          <div className='w-full flex flex-col items-center gap-2'>
            <Controller
              name="numero_piece_identite"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <label className="input w-2/3">
                  <span className="label">Numéro pièce d'identité</span>
                  <input 
                    type="text" 
                    {...field}
                    value={field.value || ''} 
                  />
                </label>
              )}
            />
          </div>
        </div>

        <div className="flex flex-col items-center gap-2">
          <AddressFields control={control} errors={errors} apiErrors={apiErrors} without={['pays']} />
          
          <div className='w-full flex flex-col items-center gap-2'>
            <Input.PhoneNumber control={control}
              name="telephone"
              className="w-2/3"
              validator={{hasError, getErrorMessage}}
            />
          </div>

          <div className='w-full flex flex-col items-center gap-2'>
            <Input.Email control={control}
              name="email"
              className="w-2/3"
              validator={{hasError, getErrorMessage}}
            />
          </div>

          <div className='w-full flex flex-col items-center gap-2'>
            <Controller
              name="profession"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <label className="input w-2/3">
                  <span className="label">Profession</span>
                  <input 
                    type="text" 
                    {...field}
                    value={field.value || ''} 
                  />
                </label>
              )}
            />
          </div>
        </div>
      </div>
  )
}

export default PersonnePhysiqueForm